<template>
  <div class="allocation" data-testid="portfolio-allocation">
    <section class="allocation__section">
      <Heading class="allocation__title" :level="2">{{ title }}</Heading>
      <AllocationChart
        class="allocation__chart"
        :sections="sections"
        :total-balance="totalBalance"
        :updated-at="updatedAt"
        :is-loading="isLoading"
        :has-error="hasError"
        @on-retry="getAllocationData"
      />
    </section>
    <AllocationChartLegend
      :sections="sections"
      :is-loading="isLoading"
      :has-error="hasError"
    />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';

import { Heading } from '@warrenbrasil/nebraska-web';
import { AllocationChart } from '@/modules/wealth/components/AllocationChart';
import { AllocationChartLegend } from './components/AllocationChartLegend';

import {
  getPortfolioSectorAllocation,
  PortfolioSection
} from '@/modules/wealth/services/portfolio';

interface Props {
  portfolioId: string;
}
const props = defineProps<Props>();

const isLoading = ref(true);
const hasError = ref(false);
const sections = ref<PortfolioSection[]>([]);
const totalBalance = ref<string | null>(null);
const updatedAt = ref<string | null>(null);
const title = ref<string | null>(null);

const getAllocationData = async () => {
  isLoading.value = true;
  hasError.value = false;

  try {
    const data = await getPortfolioSectorAllocation(props.portfolioId);

    title.value = data.title || 'Alocação por setor';
    sections.value = data.sections;
    totalBalance.value = data.totalBalance.formatted;
    updatedAt.value = data.updatedAt.formatted;
  } catch {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
};

onMounted(async () => {
  await getAllocationData();
});
</script>
<style lang="less" scoped>
.allocation {
  margin-top: @size-spacing-x800;

  &__section {
    margin: 0 auto;
    padding: 0 @size-spacing-x400;

    .from-md({
      max-width: calc(800px + 2 * @size-spacing-x800);
      padding: 0 @size-spacing-x800;
    });
  }

  &__title {
    margin-bottom: @size-spacing-x500;
  }

  &__chart {
    margin-bottom: @size-spacing-x800;
  }
}
</style>
